module.exports = __webpack_public_path__ + "static/chloe-the-engineer-e80a6ff1af6c71ff6b6598369b42bbb0.jpg";